module.exports = __webpack_public_path__ + "img/movemini.f8e3e3de.jpg";